import { createFileRoute } from '@tanstack/react-router'
import { AuthContainer } from '@/components/auth/AuthContainer'

/**
 * OAuth Callback Route
 *
 * This route handles OAuth/SAML callbacks from identity providers (Wrike, Azure, etc.)
 * It processes the authorization code and exchanges it for tokens.
 *
 * Flow:
 * 1. Identity provider redirects to /callback?code=XXX&state=YYY
 * 2. AuthContainer's useCustomAuth hook detects the code and processes it
 * 3. User is redirected based on their role (CEO -> /big-numbers, others -> /dashboard)
 */
export const Route = createFileRoute('/_unauth/callback')({
  component: CallbackPage,
})

function CallbackPage() {
  // Don't specify redirectTo - let AuthContainer determine based on user role
  return (
    <AuthContainer initialState="signIn" />
  )
}
